import { StyleSheet } from 'react-native';
import { HStack, VStack } from '../../../components/primitives/Stack';
import { Text } from '../../../components/primitives/Text';
import { Toggle } from '../../../components/primitives/Toggle';
import { useTranslation } from '../../../contexts/TranslationContext';
import { colors } from '../../../theme/colors';
import { useAnalyticsConsent } from '../hooks/useAnalyticsConsent';
import { SettingsSection } from './SettingsSection';

export function AnalyticsSection() {
  const { t } = useTranslation();
  const { enabled, isReady, setConsent } = useAnalyticsConsent();

  return (
    <SettingsSection title={t('settings.analytics.title')}>
      <HStack spacing="md" align="center" justify="between">
        <VStack spacing="xxs" style={styles.info}>
          <Text variant="bodySmall" color={colors.text.primary} style={styles.label}>
            {t('settings.analytics.toggleLabel')}
          </Text>
          <Text variant="caption" color={colors.text.tertiary}>
            {t('settings.analytics.toggleHint')}
          </Text>
        </VStack>
        <Toggle
          value={enabled}
          onValueChange={setConsent}
          disabled={!isReady}
          accessibilityLabel={t('settings.analytics.toggleLabel')}
          accessibilityHint={t('settings.analytics.toggleHint')}
        />
      </HStack>
    </SettingsSection>
  );
}

const styles = StyleSheet.create({
  info: {
    flex: 1,
    minWidth: 0,
  },
  label: {
    fontWeight: '500',
  },
});
